module.exports = __webpack_public_path__ + "static/media/estee_lauder_bg.f61a4f80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/customers/estee_lauder_bg.jpg
// module id = 127
// module chunks = 0